import { render, staticRenderFns } from "./list-categories.vue?vue&type=template&id=16eaeb20&scoped=true&"
import script from "./list-categories.vue?vue&type=script&lang=ts&"
export * from "./list-categories.vue?vue&type=script&lang=ts&"
import style0 from "./list-categories.vue?vue&type=style&index=0&id=16eaeb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eaeb20",
  null
  
)

export default component.exports